import { StorageManager } from './storage-manager'

/**
 * Manages the state of product comparisons
 */
export class ComparisonState {
  constructor() {
    this.storageManager = new StorageManager()
    this.currentIDs = []
    this.currentImages = []
    this.currentDescriptions = []
  }

  loadFromStorage() {
    const storedIDs = this.storageManager.readIDs()
    const storedImages = this.storageManager.readImages()
    const storedDescriptions = this.storageManager.readDescriptions()

    return {
      ids: storedIDs,
      images: storedImages,
      descriptions: storedDescriptions,
      hasData: storedIDs.length > 0 && storedImages.length > 0 && storedDescriptions.length > 0
    }
  }

  add(id, image, description) {
    this.currentIDs.push(Number(id))
    this.currentImages.push(image)
    this.currentDescriptions.push(description)
    this.persist()
  }

  remove(id, image, description) {
    this.currentIDs = this.currentIDs.filter(item => item != id)
    this.currentImages = this.currentImages.filter(item => item !== image)
    this.currentDescriptions = this.currentDescriptions.filter(item => item !== description)
    this.storageManager.remove(id, image, description)
  }

  clear() {
    this.currentIDs = []
    this.currentImages = []
    this.currentDescriptions = []
    this.storageManager.clear()
  }

  persist() {
    const storedIDs = this.storageManager.readIDs()
    const storedImages = this.storageManager.readImages()
    const storedDescriptions = this.storageManager.readDescriptions()
    
    // Deduplicate by ID using a Map
    const merged = new Map()
    
    // Add stored items
    storedIDs.forEach((id, index) => {
      merged.set(id, {
        id,
        image: storedImages[index],
        description: storedDescriptions[index]
      })
    })
    
    // Add/overwrite with current items
    this.currentIDs.forEach((id, index) => {
      merged.set(id, {
        id,
        image: this.currentImages[index],
        description: this.currentDescriptions[index]
      })
    })
    
    // Convert back to arrays
    const items = Array.from(merged.values())
    const allIDs = items.map(item => item.id)
    const allImages = items.map(item => item.image)
    const allDescriptions = items.map(item => item.description)
    
    this.storageManager.save(allIDs, allImages, allDescriptions)
    
    // Clear current after persisting
    this.currentIDs = []
    this.currentImages = []
    this.currentDescriptions = []
    
    return allIDs
  }

  getCount() {
    return this.loadFromStorage().ids.length
  }
}
